import { moment } from "@msuite/utils/date";
import { CommandMap } from "./command-map";
import { CommandNews } from "./command-news";
import { CommandPlan } from "./command-plan";
import { CommandStatistics } from "./command-statistics";
import "./command.css";

export function Command() {
	return (
		<div className="v-stack w-full h-full absolute inset-0 bg-primary-100 p-4 gap-4 command-view">
			<p className="heading">{moment().dateFormat()}</p>
			<div
				className="grid flex-1 gap-4 min-h-0"
				style={{
					gridTemplateColumns: "1fr 25vw",
				}}
			>
				<CommandPlan />
				<div className="w-full h-full v-stack grow-0 min-h-0">
					<CommandMap />
					<CommandStatistics />
					<CommandNews />
				</div>
			</div>
		</div>
	);
}
